import React, { useState } from 'react';
import { SectionHead, Icon } from './Primitives';
import './UnityLessonShowcase.css';
const styles = ['Explore an idea', 'Reveal the detail', 'See the difference'];
export default function UnityLessonShowcase() {
  const [tab, setTab] = useState(0);
  const [reveal, setReveal] = useState(false);
  const [step, setStep] = useState(0);
  return (
    <section className="ul-section ul-lesson" id="lesson-quality">
      <div className="ul-container">
        <SectionHead
          center
          eyebrow="Beautiful lessons. Meaningful interaction."
          title={
            <>
              Give knowledge a format
              <br />
              people want to explore.
            </>
          }
        >
          Reveal an explanation. Work through a process. Compare two perspectives. Use rich learning
          formats to make the important ideas stick.
        </SectionHead>
        <div className="ul-lesson-stage">
          <div className="ul-lesson-label">
            <span>TRY A LEARNING FORMAT</span>
            <span>Illustrative learning sample</span>
          </div>
          <div className="ul-lesson-tabs" aria-label="Learning sample format">
            {styles.map((name, i) => (
              <button
                type="button"
                aria-pressed={tab === i}
                key={name}
                onClick={() => {
                  setTab(i);
                  setReveal(false);
                  setStep(0);
                }}
              >
                {name}
              </button>
            ))}
          </div>
          <div className="ul-lesson-content" aria-live="polite">
            {tab === 0 ? (
              <>
                <div className="ul-lesson-intro">
                  <span className="ul-tag">Process explorer</span>
                  <h3>
                    Turn information
                    <br />
                    into understanding.
                  </h3>
                  <p>Select a step to explore how a strong learning explanation comes together.</p>
                </div>
                <div className="ul-process-demo">
                  <div className="ul-process-choices">
                    {['Give context', 'Make it concrete', 'Check understanding'].map((s, i) => (
                      <button
                        type="button"
                        key={s}
                        aria-pressed={step === i}
                        onClick={() => setStep(i)}
                      >
                        <span>0{i + 1}</span>
                        {s}
                      </button>
                    ))}
                  </div>
                  <div className="ul-process-explain">
                    <Icon name={['globe', 'file', 'check'][step]} size={28} />
                    <h4>
                      {
                        [
                          'Start with why it matters.',
                          'Bring the idea into focus.',
                          'Make space to apply it.',
                        ][step]
                      }
                    </h4>
                    <p>
                      {
                        [
                          'Connect the topic to a situation your learners recognise. Give them a reason to care before adding detail.',
                          'A familiar example helps learners connect new information to something they already understand.',
                          'A useful question reveals understanding and gives the learner a reason to revisit an explanation.',
                        ][step]
                      }
                    </p>
                  </div>
                </div>
              </>
            ) : tab === 1 ? (
              <>
                <div className="ul-lesson-intro">
                  <span className="ul-tag">Reveal card</span>
                  <h3>
                    A small moment.
                    <br />A clearer idea.
                  </h3>
                  <p>Give the learner a question, then let them reveal the explanation.</p>
                </div>
                <button
                  type="button"
                  className={`ul-reveal-card ${reveal ? 'is-revealed' : ''}`}
                  aria-expanded={reveal}
                  onClick={() => setReveal(!reveal)}
                >
                  <Icon name={reveal ? 'check' : 'spark'} size={36} />
                  <h4>
                    {reveal
                      ? 'Start from what they know.'
                      : 'What makes a new idea easier to understand?'}
                  </h4>
                  <p>
                    {reveal
                      ? 'Connect the new idea to an example your learner already recognises.'
                      : 'Select to reveal the explanation'}
                  </p>
                  <span>
                    {reveal ? 'Show question' : 'Reveal answer'} <Icon size={16} />
                  </span>
                </button>
              </>
            ) : (
              <>
                <div className="ul-lesson-intro">
                  <span className="ul-tag">Compare perspectives</span>
                  <h3>
                    Help the difference
                    <br />
                    become obvious.
                  </h3>
                  <p>
                    Put two explanations side by side so the learner can inspect the distinction.
                  </p>
                </div>
                <div className="ul-compare-demo">
                  <article>
                    <span>INFORMATION</span>
                    <h4>Here are the facts.</h4>
                    <p>A list introduces the topic and its key terms.</p>
                  </article>
                  <article>
                    <span>UNDERSTANDING</span>
                    <h4>Here is how it fits.</h4>
                    <p>Context and an example help connect those facts to a useful decision.</p>
                  </article>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="ul-lesson-formats">
          <span>Visual explanations</span>
          <span>Interactive practice</span>
          <span>Worked examples</span>
          <span>Mobile-friendly learning</span>
        </div>
      </div>
    </section>
  );
}
